import api from './../plugins/httpRequest'

const uri = "/api/bean-recharges";

const apiGet = (params)=>{
    if (params && params.id){
        return api.get(uri + "/" + params.id)
    }
    return api.get(uri, {params})
}

export default {
    namespaced: true,
    state: {
        list:[],
        detail:{},
        total : 0,
        perPage : 0,
        page : 1,
        loading:false
    },
    mutations: {
        LIST(state, data) {
            state.loading = false
            state.list = data;
            let pageInfo = sessionStorage.getItem('pageInfo');
            if (pageInfo) {
                let [total,perPage,page] = pageInfo.split(",");
                state.total = parseInt(total);
                state.perPage = parseInt(perPage);
                state.page = parseInt(page);
            }
        },
        DETAIL(state, data) {
            state.loading = false
            state.detail = data;
        }
    },
    actions: {
        get({commit,state},params) {
            state.loading = true;
            apiGet(params).then(function(res) {
                if (params && params.id){
                    commit('DETAIL', res.data);
                }else {
                    commit('LIST', res.data);
                }
            },function() {
                state.loading = false;
            });
        }
    }
}
